<mat-form-field
  class="me-2"
  [ngClass]="{
    'alert-select': field.varName === 'AlertIDs' || field.varName === 'AlertID',
    'policy-review': field.controlType === 'bridgeidselect',
  }"
>
  <mat-label>{{ dropdownLoading ? 'Loading...' : field.label }}</mat-label>
  <mat-chip-grid
    #chipGrid
    aria-label="{{ field.label }} selection"
    [disabled]="dropdownLoading"
    [ngClass]="{
      'no-values': chips().length <= 0,
    }"
  >
    @for (chip of chips(); track $index) {
      <mat-chip-row (removed)="remove(chip)">
        {{
          field.controlType === 'bridgeidselect'
            ? getOpportunityDisplay(chip)
            : chip
        }}
        <button
          type="button"
          matChipRemove
          [attr.aria-label]="
            'remove ' + field.controlType === 'bridgeidselect'
              ? getOpportunityDisplay(chip)
              : chip
          "
        >
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>
  <input
    #chipInput
    placeholder="Select {{ field.label }}..."
    name="currentChip"
    [disabled]="dropdownLoading"
    [matAutocomplete]="chipFilterAuto"
    [matChipInputFor]="chipGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [matChipInputAddOnBlur]="false"
    [(ngModel)]="currentChip"
    (blur)="onBlur()"
  />
  <mat-autocomplete
    #chipFilterAuto="matAutocomplete"
    (optionSelected)="selected($event)"
  >
    @for (chip of filteredChips(); track chip) {
      <mat-option
        matTooltipShowDelay="500"
        matTooltipClass="chipOptionTooltip"
        [matTooltip]="chip.BridgeDesc ? chip.BridgeDesc : ''"
        [value]="
          field.controlType === 'bridgeidselect' ? chip.BridgeID : chip.value
        "
      >
        {{
          field.controlType === 'bridgeidselect'
            ? chip.BridgeName
            : chip.display
        }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
